// extracted by mini-css-extract-plugin
export default {"resumeContainer":"Resume_resumeContainer__X8Idp","embedContainer":"Resume_embedContainer__zdhUf","rightButtonContainer":"Resume_rightButtonContainer__Sjbij"};